(() => {
const setupProductHelp = () => {
  const info = document.querySelector('.studio-product-info');
  const floatingHelp = document.querySelector('.mmlc-whatsapp--product');
  if (!info || !floatingHelp || !('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(([entry]) => {
    floatingHelp.hidden = entry.isIntersecting;
  });
  observer.observe(info);
};
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupProductHelp, {once:true});
} else {
  setupProductHelp();
}
const MmlcTermsBase = customElements.get('terms_and_condition-checkbox');
if (MmlcTermsBase && !customElements.get('mmlc-terms-checkbox')) customElements.define('mmlc-terms-checkbox', class extends MmlcTermsBase {});
if (typeof subscribe === 'function' && !window.mmlcProductSubscribed) {
  window.mmlcProductSubscribed = true;
  subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
    const section = document.getElementById(`MainProduct-${data.sectionId}`) || document.getElementById(`section-${data.sectionId}`);
    if (!section || !data.html) return;
    for (const selector of ['.studio-product-facts','.studio-product-info']) {
      const target = section.querySelector(selector);
      const source = data.html.querySelector(selector);
      if (target && source) target.innerHTML = source.innerHTML;
    }
  });
}
if (!customElements.get('mmlc-payment-choice')) {
  customElements.define('mmlc-payment-choice', class extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.abort = new AbortController();
      this.form.addEventListener('change', () => this.sync(), {signal:this.abort.signal});
      this.sync();
    }
    disconnectedCallback() { this.abort?.abort(); }
    sync() {
      const id = this.form.querySelector('[name="id"]')?.value;
      let active = false;
      this.querySelectorAll('[data-variant]').forEach(field => {
        const selected = field.dataset.variant === id;
        field.disabled = !selected;
        field.hidden = !selected;
        if (selected) {
          active = true;
          if (!field.querySelector('input[name="selling_plan"]:checked')) {
            const defaultOption = field.querySelector('input[name="selling_plan"]');
            if (defaultOption) defaultOption.checked = true;
          }
        }
      });
      this.hidden = !active;
      const payment = this.form.querySelector('.shopify-payment-button');
      if (payment) payment.hidden = active;
    }
  });
}
})();
